import React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spinner } from "@shopify/polaris";
import reverselogo from "../components/UI/assets/reverse-logo.svg";
import classes from "./Errorpage.module.css";
import { CONNECTING, ROOT } from "../navigation/CONSTANTS";

/*
 * Shown while the embedded session is still booting or OAuth is about to
 * kick off. Kept outside PageLayout so Shopify admin does not highlight Help
 * (or any other nav item) during install/reinstall.
 */
function Connecting() {
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => state.auth);

  if (isLoggedIn) {
    const from = location.state?.from;
    const destinationPath =
      from?.pathname && from.pathname !== CONNECTING ? from.pathname : ROOT;

    return (
      <Redirect
        to={{
          pathname: destinationPath,
          search: from?.search || "",
          hash: from?.hash || "",
        }}
      />
    );
  }

  return (
    <div className={classes.errorMainWrapper}>
      <div className={classes.errorInnerWrapper}>
        <div className={classes.logoWrapper}>
          <img alt="logo" className={classes.imgLogo} src={reverselogo} />
        </div>
        <div className={classes.contentWrapper}>
          <div className={classes.mainTitle}>Connecting your store</div>
          <div className={classes.paraText}>
            Authentication is in progress. You’ll be redirected to the app
            shortly.
          </div>
          <div className={classes.spinnerWrapper}>
            <Spinner accessibilityLabel="Connecting your store" size="large" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Connecting;
